import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  YouTube,
} from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import ImageViewer from "../../../../components/ImageViewer";
import VideoPlayer from "../../../../components/VideoPlayer";
import { getYoutubeVideoThumbnail } from "../../../../utils";
import ReactPlayer from "react-player";
import OAuth from "../../OAuth";
import { getOAuthData } from "../../../network/getOAuthData";
import AudioPlayer from "../../../../components/AudioPlayer";

export const Datatype = {
  LIST: "list",
  STRING: "string",
  IMAGES: "images",
  VIDEOS: "videos",
  AUDIOS: "audios",
};

const DropdownContainer = (props) => {
  const { label, data, type } = props;

  const [show, setShow] = useState(false);
  const [imageViewer, setImageViewer] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [videoViewer, setVideoViewer] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");

  const [imageData, setImageData] = useState([]);
  const [audioData, setAudioData] = useState([]);

  const onOpenImageViewer = (index) => {
    setSelectedIndex(index);
    setImageViewer(true);
  };

  const onOpenVideoPlayer = (url) => {
    setSelectedVideo(url);
    setVideoViewer(true);
  };

  const getImageDataList = async () => {
    if (Datatype.IMAGES === type) {
      const tempData = [];
      data?.forEach(async (item) => {
        tempData.push(
          (async () => {
            const src = await getOAuthData(item.url);
            return {
              ...item,
              src: src ?? item.url,
            };
          })()
        );
      });
      setImageData(await Promise.all(tempData));
    }
  };

  useEffect(() => {
    getImageDataList();
  }, [data, type, show]);

  const renderData = () => {
    switch (type) {
      case Datatype.LIST:
        return data?.length > 0 ? (
          data?.map((item, index) => (
            <div key={`key-${index}`} className="flex justify-between px-5">
              {item?.label && (
                <div className="text-neutral-800 text-[12px] font-['Poppins-Regular'] leading-[30px]">
                  &#x2022;{"  "}
                  {item.label}
                </div>
              )}
              {item?.value && (
                <div className="text-zinc-500 text-[12px] font-['Poppins-Light'] leading-[30px]">
                  {item.value}
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="flex justify-center px-5 pb-1">
            <div className="text-zinc-500 text-[12px] font-['Poppins-Light'] leading-[30px]">
              {"No data found"}
            </div>
          </div>
        );
      case Datatype.STRING:
        return (
          <h2 className="text-zinc-500 text-[12px] font-['Poppins-Regular'] leading-[20px] px-5 pb-1">
            {data}
          </h2>
        );
      case Datatype.IMAGES:
        return data?.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-1 px-5 pb-1">
            {data?.map((item, index) => {
              const imageUrl =
                item?.variant &&
                Object.keys(item.variant).length > 0 &&
                item.variant.x240
                  ? item.variant.x240
                  : item?.url;
              return (
                <div
                  key={`IMG-${index}`}
                  className="active:bg-opacity-40"
                  onClick={onOpenImageViewer?.bind(this, index)}
                >
                  <OAuth
                    altSrc={require("../../../../assets/images/user-img.png")}
                    component={
                      <img
                        className="max-w-full rounded-sm object-cover aspect-square active:bg-opacity-40 cursor-pointer"
                        src={imageUrl}
                        alt=""
                      />
                    }
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex justify-center px-5 pb-1">
            <div className="text-zinc-500 text-[12px] font-['Poppins-Light'] leading-[30px]">
              {"No images found"}
            </div>
          </div>
        );
      case Datatype.VIDEOS:
        return data?.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-1 px-5 pb-1">
            {data?.map((item, index) => (
              <div
                key={`VID-${index}`}
                className="relative active:bg-opacity-40 cursor-pointer"
                onClick={onOpenVideoPlayer?.bind(this, item?.url)}
              >
                <div className="absolute flex justify-center items-center top-0 w-full rounded-sm aspect-square">
                  {" "}
                  <YouTube className="text-4xl text-[#FF0000] text-opacity-50" />{" "}
                </div>
                <img
                  className="max-w-full rounded-sm object-cover aspect-square"
                  src={getYoutubeVideoThumbnail(item?.url)}
                  alt=""
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="flex justify-center px-5 pb-1">
            <div className="text-zinc-500 text-[12px] font-['Poppins-Light'] leading-[30px]">
              {"No videos found"}
            </div>
          </div>
        );
      case Datatype.AUDIOS:
        return data?.length > 0 ? (
          <div className="flex flex-col gap-2 px-5 pb-3">
            {data?.map((item, index) => (
              <div key={`AUD-${index}`} className="">
                <OAuth
                  altSrc={item.url}
                  component={<AudioPlayer url={item?.url} />}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="flex justify-center px-5 pb-1">
            <div className="text-zinc-500 text-[12px] font-['Poppins-Light'] leading-[30px]">
              {"No audios found"}
            </div>
          </div>
        );
      default:
        return (
          <div className="flex justify-center px-5">
            <div className="text-zinc-500 text-[12px] font-['Poppins-Light'] leading-[30px]">
              {"No data found"}
            </div>
          </div>
        );
    }
  };

  return (
    <Box>
      <div className="flex justify-between items-center py-1 px-4">
        <div className="text-neutral-800 text-xs font-['Poppins-Medium'] leading-[30px]">
          {label}
        </div>
        <IconButton onClick={setShow?.bind(null, !show)} size="small">
          {show ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </IconButton>
      </div>
      <div className="overflow-hidden" style={{ height: show ? "100%" : 0 }}>
        {renderData()}
      </div>
      {type === Datatype.IMAGES && (
        <ImageViewer
          visible={imageViewer}
          selectedIndex={selectedIndex}
          imageList={imageData ?? []}
          onClose={setImageViewer?.bind(null, false)}
        />
      )}
      {type === Datatype.VIDEOS && (
        <VideoPlayer
          url={selectedVideo}
          open={videoViewer}
          onClose={setVideoViewer?.bind(null, false)}
        />
      )}
    </Box>
  );
};

export default DropdownContainer;
